import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { DeliveryTicketRequestDTO } from 'src/app/domain/DeliveryTicketRequestDTO';
import { DeliveryTicketResponseDTO } from 'src/app/domain/DeliveryTicketResponseDTO';
import { ItemSummaryDTO } from 'src/app/domain/ItemSummaryDTO';


export interface Order {
  id: number
  batchNumber: string,
  stockId: number,
  opportunityId: number,
  opportunityName : String ,
  productType: String,
  productKind: String,
  partNumber: number,
  converageEnd: Date,
  delta: number,
  provisionValue: number
  hasCoverage : Boolean;
  productId : number;
  count : number;
  startDate : Date;
  productCategory : String;
  productItem : String;
  price : number;
  moduleId : number ;
  moduleName : String;
  salesOrderItem :String;
}


export interface OrderRequest{
  id: number;
  productId : number;
  opportunityId: number;
  stockId: number;
  count: number;
  startDate: any;
  endDate:any;
  hasCoverage: Boolean;
  provisionValue: number;
  price: number;
  moduleId : number ;
  salesOrderItem :String;

  // for stock 
  batchNumber : string ;
  purchaseDate : any;
  isRabet : Boolean;
  poNumber : number ;
  status : number;
  customerStock : Boolean;
  sellingPrice: number;
  costPrice : number;
}




@Injectable({
  providedIn: 'root'
})
export class OrderService {

  PATH = "/appliances/api/v2/order"
  private DELIVERY_TICKETS_PATH = "/appliances/api/v2/delivery-tickets"; 

  constructor(private httpClient: HttpClient) { }

  getOrders(): Observable<Order[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<Order[]>(this.PATH + '/' ,{headers})
      .pipe(catchError(this.errorHandler));
  }

  getOrderById(id): Observable<Order> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<Order>(this.PATH + '/' + id , {headers}).pipe(catchError(this.errorHandler));
  }

  createOrder(order): Observable<Order> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<Order>(this.PATH + '/', order, { headers }).pipe(
      catchError(this.errorHandler)
    );
  }

  updateOrder(order) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.put(this.PATH + '/' , order,{ headers } ).pipe(catchError(this.errorHandler));
  }

  deleteOrder(id) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.delete(this.PATH + '/' + id , {headers}).pipe(catchError(this.errorHandler));
  }

  renewOrders(dates: any) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.put(this.PATH + '/renewOrders', dates ,{ headers }).pipe(catchError(this.errorHandler));
  }

  getDeliveryTicketsByMasterOrderId(masterOrderId: number): Observable<DeliveryTicketResponseDTO[]> {
    const url = `${this.DELIVERY_TICKETS_PATH}/master-order/${masterOrderId}`;

    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<DeliveryTicketResponseDTO[]>(url , {headers}).pipe(
      catchError(this.errorHandler)
    );
  }

  createDeliveryTicket(requestDTO: DeliveryTicketRequestDTO): Observable<DeliveryTicketResponseDTO> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<DeliveryTicketResponseDTO>(this.DELIVERY_TICKETS_PATH, requestDTO, { headers }).pipe(
      catchError(this.errorHandler)
    );
  }

  getDeliveryTicketByStockItemId(stockItemId: number): Observable<DeliveryTicketResponseDTO> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<DeliveryTicketResponseDTO>(this.DELIVERY_TICKETS_PATH + '/stock-item/' + stockItemId , {headers}).pipe(catchError(this.errorHandler));

  }

  updateDeliveryTicket(id: number, requestDTO: DeliveryTicketRequestDTO): Observable<DeliveryTicketResponseDTO> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = `${this.DELIVERY_TICKETS_PATH}/${id}`;
    return this.httpClient.put<DeliveryTicketResponseDTO>(url, requestDTO, { headers }).pipe(
      catchError(this.errorHandler)
    );
  }
  getItemSummary(deliveryTicketId: number): Observable<ItemSummaryDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<ItemSummaryDTO[]>(`${this.DELIVERY_TICKETS_PATH}/item-summary/${deliveryTicketId}` , {headers}).pipe(catchError(this.errorHandler));

  }

  
  updateMultibleTickets(requestDTO: DeliveryTicketRequestDTO[]): Observable<DeliveryTicketResponseDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = `${this.DELIVERY_TICKETS_PATH}/bulk-update`;
    return this.httpClient.put<DeliveryTicketResponseDTO[]>(url, requestDTO, { headers }).pipe(
      catchError(this.errorHandler)
    );
  }

    

  
  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }

  
  



}
